import { jsx as _jsx } from "react/jsx-runtime";
import { attributesFromSchema, entityFromSchema } from '../../../lib';
import { List } from '../../list';
import { AttributeListItem } from './AttributeListItem';
export function AttributeList({ schema, parents }) {
    if (typeof schema !== 'object' || schema === null) {
        return null;
    }
    // Since these docs are not editable, don't need to display empty child attributes
    const hasAttributes = attributesFromSchema(schema).attributes.length > 0;
    if (!hasAttributes) {
        return null;
    }
    const entity = entityFromSchema(schema);
    return (_jsx(List, { children: entity.attributes.map((attribute) => (_jsx(AttributeListItem, { entity: entity, attribute: attribute, parents: parents }, attribute.name))) }));
}
